// extracted by mini-css-extract-plugin
export default {"intro":"LogoLx_intro__TQYQB","_":"LogoLx____4FNPl","lPath":"LogoLx_lPath__Rot1K","xPath":"LogoLx_xPath__MxdGH"};